export default __webpack_public_path__ + "static/media/list-active.401310fa.svg";